var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ConsigneeShipperAndNotifyAddress"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "100%", "margin-bottom": "5px" },
          attrs: { "label-width": "120px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          "method-params": { customer: true },
                          "default-value": _vm.filter.partnerId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.filter.partnerId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_DestinationPort") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            this.filter.lob === "SE" || this.filter.lob === "SI"
                              ? _vm.selectTypeNames.basic_data_Seaport
                              : _vm.selectTypeNames.basic_data_Airport,
                          filterable: "",
                          "default-value": _vm.filter.pod
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.filter.pod = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DestinationAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            overseaAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.filter.destinationAgent,
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          "callback-params": { key: "destinationAgent" },
                          "callback-method-type": "value"
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.filter.destinationAgent = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ShipperId") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.shipperCode,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "shipperCode", $$v)
                          },
                          expression: "filter.shipperCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ConsigneeId") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.consigneeCode,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "consigneeCode", $$v)
                          },
                          expression: "filter.consigneeCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_NotifyId") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.notifyCode,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "notifyCode", $$v)
                          },
                          expression: "filter.notifyCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.consignorName") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.shipperEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "shipperEnterpriseName", $$v)
                          },
                          expression: "filter.shipperEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.consigneeName") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.consigneeEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "consigneeEnterpriseName", $$v)
                          },
                          expression: "filter.consigneeEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.notifyingName") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.notifyEnterpriseName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "notifyEnterpriseName", $$v)
                          },
                          expression: "filter.notifyEnterpriseName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { staticStyle: { "text-align": "left" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toQuery } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.reset } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "config-module": "12011501",
          "wrap-text": true,
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          }
        }
      }),
      _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
              width: "100%"
            }
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_JobBillAddress_addBillAddress"],
                        expression: "['button_JobBillAddress_addBillAddress']"
                      }
                    ],
                    attrs: { no: "addMailingAddress", type: "primary" },
                    on: { click: _vm.addMailingAddress }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_JobBillAddress_editBillAddress"],
                        expression: "['button_JobBillAddress_editBillAddress']"
                      }
                    ],
                    attrs: { no: "editMailingAddress", type: "primary" },
                    on: { click: _vm.editMailingAddress }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_JobBillAddress_deleteBillAddress"],
                        expression:
                          "['button_JobBillAddress_deleteBillAddress']"
                      }
                    ],
                    attrs: { no: "deleteMailingAddress", type: "danger" },
                    on: { click: _vm.deleteMailingAddress }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                )
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.choose(["shipper"])
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isSeaHouseChannel
                          ? _vm.$t("SeaExport.CopyManifestShipper")
                          : _vm.$t("SeaExport.CopyShipper")
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.choose(["consignee"])
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isSeaHouseChannel
                          ? _vm.$t("SeaExport.CopyManifestConsignee")
                          : _vm.$t("SeaExport.CopyConsignee")
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.choose(["notify"])
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isSeaHouseChannel
                          ? _vm.$t("SeaExport.CopyManifestNotify")
                          : _vm.$t("SeaExport.CopyNotify")
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.choose(["shipper", "consignee", "notify"])
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("mailing-address-maintain-dialog", {
        attrs: {
          visible: _vm.mailingAddressMaintainDialog.visible,
          "dialog-title": _vm.mailingAddressMaintainDialog.title,
          form: _vm.mailingAddressMaintainDialog.form,
          type: _vm.mailingAddressMaintainDialog.type,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.mailingAddressMaintainDialog, "visible", $event)
          },
          callback: _vm.toQuery
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }